import React from 'react';
import { useTranslation } from 'react-i18next';
// mui
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
////////////////////////////////////////////////

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <Box
      display='flex'
      height='100vh'
      alignItems='center'
      flexDirection='column'
      justifyContent='center'
    >
      <Typography
        mb='20px'
        width='100%'
        variant='h5'
        component='h1'
        align='center'
        fontWeight={600}
        fontSize='2.5rem'
        color='text.primary'
        fontFamily='Urbanist'
      >
        {t('errors.error404')}
      </Typography>
      <Typography
        mb='40px'
        width='100%'
        variant='h5'
        component='p'
        align='center'
        fontWeight={400}
        fontSize='1.2rem'
        color='text.primary'
        fontFamily='Urbanist'
      >
        {t('labels.sorryThePageNotFound')}
      </Typography>
      <img
        alt='Not Found'
        src='https://i.imgur.com/Q2BAOd2.png'
        style={{ width: 300, height: 'auto' }}
      />
    </Box>
  );
};

export default NotFound;
